import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-pink-50 text-gray-800 px-4 text-center">
      <h1 className="text-6xl font-extrabold text-pink-600 mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-2">Oops! This page seems to have taken a skincare break.</h2>
      <p className="mb-6 text-gray-600">
        At <span className="font-semibold">Shinzura</span>, we believe in glowing skin and smooth experiences.
        Unfortunately, this page isn’t part of your beauty routine.
      </p>
      <Link
        to="/"
        className="px-6 py-3 bg-pink-600 text-white rounded-lg hover:bg-pink-700 transition duration-300 font-medium"
      >
        Back to Home – Make You Confident ✨
      </Link>
    </div>
  );
};

export default NotFound;
